import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase'; // ※パスは環境に合わせて調整してください
import { FaStar } from 'react-icons/fa';
import "./SurveyModal.css"; // CSSも分離

// --- Modal内専用の翻訳データ ---
const modalTranslations = {
  ja: {
    title: 'TOIMAPの改善にご協力ください',
    desc: 'このマップ機能の使いやすさを評価してください',
    star1: '使いにくい',
    star5: '使いやすい',
    placeholder: 'ご意見、不具合報告、欲しい機能などご自由にお書きください...',
    submit: '送信する',
    cancel: 'キャンセル',
    thanks: 'ご意見ありがとうございます！',
    error: '送信エラーが発生しました。',
  },
  en: {
    title: 'Help us improve TOIMAP',
    desc: 'How is your experience with this map?',
    star1: 'Poor',
    star5: 'Excellent',
    placeholder: 'Feel free to share your thoughts, bug reports, or feature requests...',
    submit: 'Send Feedback',
    cancel: 'Cancel',
    thanks: 'Thank you for your feedback!',
    error: 'An error occurred.',
  }
};

const SurveyModal = ({ isOpen, onClose, currentLang }) => {
  const location = useLocation();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);

  // 翻訳ヘルパー
  const t = modalTranslations[currentLang] || modalTranslations['en'];

  if (!isOpen) return null;

  // 送信ハンドラ
  const handleSubmit = async () => {
    if (rating === 0 && comment.trim() === "") return;

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, "feedbacks"), {
        rating: rating,
        comment: comment,
        path: location.pathname,
        lang: currentLang,
        createdAt: serverTimestamp(),
        userAgent: navigator.userAgent
      });

      setIsSent(true);

      // 3秒後に閉じてリセット
      setTimeout(() => {
        handleClose();
      }, 3000);

    } catch (error) {
      console.error("Feedback error:", error);
      alert(t.error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // 閉じる処理（状態リセット含む）
  const handleClose = () => {
    onClose();
    // モーダルが完全に消えた後にリセット（UX向上のため遅延させても良いが、今回は即リセット）
    setTimeout(() => {
      setIsSent(false);
      setRating(0);
      setComment("");
    }, 300);
  };

  return (
    <div className="survey-modal-overlay" onClick={handleClose}>
      <div className="survey-modal-content" onClick={(e) => e.stopPropagation()}>

        {isSent ? (
          <div className="survey-sent-message">
            <h3>{t.thanks}</h3>
            <div className="check-animation">✔</div>
          </div>
        ) : (
          <>
            <h3 className="survey-title">{t.title}</h3>
            <p className="survey-desc">{t.desc}</p>

            {/* スター評価 */}
            <div className="survey-stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  className={`star-btn ${rating >= star ? 'active' : ''}`}
                  onClick={() => setRating(star)}
                >
                  <FaStar />
                </button>
              ))}
            </div>
            <div className="survey-star-labels">
              <span>{t.star1}</span>
              <span>{t.star5}</span>
            </div>

            {/* コメント欄 */}
            <textarea
              className="survey-textarea"
              placeholder={t.placeholder}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />

            {/* ボタン */}
            <div className="survey-actions">
              <button
                className="survey-btn cancel"
                onClick={handleClose}
              >
                {t.cancel}
              </button>
              <button
                className="survey-btn submit"
                onClick={handleSubmit}
                disabled={isSubmitting || (rating === 0 && comment === "")}
              >
                {isSubmitting ? '...' : t.submit}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SurveyModal;